import React from 'react';
import {
  GreenTickIcon,
  CrossFillIcon,
  COCDismissIcon,
  AIEmailIcon,
  AICallIcon,
} from '../../../assets/icons/icons';

interface StatusInfo {
  label?: string;
  description?: string;
  sentiment?: {
    type?: string;
  };
}

interface Item {
  resolved?: boolean;
  dismissed?: boolean;
  ai_type?: 'email' | 'call' | string;
  status_info?: StatusInfo;
  outcome?: string;
}

const COCStatusIcons: React.FC<{ item?: Item }> = ({ item }) => {
  if (!item) return null;

  const { resolved, dismissed, ai_type, status_info, outcome } = item;
  const label = status_info?.label;
  const sentiment = status_info?.sentiment?.type;

  //  If resolved
  if (resolved) {
    return <GreenTickIcon />;
  }

  // If dismissed (and not resolved)
  if (dismissed && !resolved) {
    return <COCDismissIcon />;
  }

  // Negative or failed outcomes
  if (
    outcome === 'Not answered' ||
    label === 'Failed' ||
    (label === 'Completed' && sentiment === 'negative')
  ) {
    return <CrossFillIcon />;
  }

  //  In progress (only if not resolved/dismissed)
  if (!resolved && !dismissed && label === 'In Progress') {
    if (ai_type === 'email') return <AIEmailIcon />;
    if (ai_type === 'call') return <AICallIcon />;
  }

  // unresolved + undismissed
  if (!resolved && !dismissed) {
    return <CrossFillIcon />;
  }
  {
    /* <MailWhiteIcon /> */
  }

  return null;
};

export default COCStatusIcons;
